const topics = [
  { name: '网红主播', count: 1286, icon: 'ri-live-line' },
  { name: '明星八卦', count: 2145, icon: 'ri-star-line' },
  { name: '社会热点', count: 987, icon: 'ri-fire-line' },
  { name: 'MCN内幕', count: 456, icon: 'ri-building-2-line' },
  { name: '直播带货', count: 823, icon: 'ri-shopping-bag-3-line' },
  { name: '饭圈塌房', count: 1678, icon: 'ri-user-unfollow-line' },
  { name: '品牌代言', count: 534, icon: 'ri-award-line' },
  { name: '综艺内幕', count: 392, icon: 'ri-tv-line' },
  { name: '合同纠纷', count: 267, icon: 'ri-file-text-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-2 text-center">
          爆料主题索引
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">按主题分类浏览 · 找到你关心的爆料</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group flex items-center gap-3 p-3.5 md:p-4 rounded-xl bg-background-50 hover:bg-accent-50 transition-colors border border-background-200/70 hover:border-accent-200/50"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-foreground-900 flex items-center justify-center shrink-0 group-hover:bg-accent-500 transition-colors">
                <i className={`${item.icon} text-white text-base md:text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-foreground-900 font-bold text-sm md:text-base leading-tight">{item.name}</h3>
                <p className="text-foreground-400 text-xs mt-0.5">{item.count} 条内容</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-accent-500 transition-colors w-4 h-4 flex items-center justify-center"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}